import React from "react";

function TableLoading(props) {
  const { children } = props;

  return <>{children}</>;
}

export default TableLoading;
